module.exports = __webpack_public_path__ + "img/Instagram.a2288dcc.png";